import { ADOnPremSensorComponent } from './component/ADOnPremSensorComponent';
import { WEB_COMPONENT_SENSOR_AD_ONPREM } from '../../../webcomponents.constants';

export { ADOnPremSensorComponent };

window.customElements.define(WEB_COMPONENT_SENSOR_AD_ONPREM, ADOnPremSensorComponent);
